const DocumentTitleFormatter = (title) => {
  return `${title} | TRC Global Mobility`;
};

export default DocumentTitleFormatter;
